module.exports = __webpack_public_path__ + "static/media/Sticker_Off.dd38dafd.png";